import { PropertyRepository } from '../repositories/PropertyRepository';
import { CreatePropertyDto, PropertyFilterDto } from '../dtos/PropertyDto';

export class PropertyService {
    static async getProperties(filters?: PropertyFilterDto) {
        try {
            return await PropertyRepository.getAll(filters);
        } catch (error) {
            console.error('Error fetching properties:', error);
            throw error;
        }
    }

    static async getProperty(id: number) {
        try {
            return await PropertyRepository.getById(id);
        } catch (error) {
            console.error(`Error fetching property ${id}:`, error);
            throw error;
        }
    }

    static async getPropertyImages(id: number) {
        try {
            return await PropertyRepository.getPropertyImages(id);
        } catch (error) {
            console.error(`Error fetching property images for ${id}:`, error);
            throw error;
        }
    }

    static async createProperty(data: CreatePropertyDto) {
        try {
            return await PropertyRepository.create(data);
        } catch (error) {
            console.error('Error creating property:', error);
            throw error;
        }
    }

    static async updateProperty(id: number, data: CreatePropertyDto) {
        try {
            return await PropertyRepository.update(id, data);
        } catch (error) {
            console.error(`Error updating property ${id}:`, error);
            throw error;
        }
    }

    static async uploadMedia(propertyId: number, files: File[], category: string, deleteIds?: number[]) {
        try {
            const formData = new FormData();
            files.forEach(file => formData.append('new_files[]', file));
            formData.append('category', category);

            if (deleteIds && deleteIds.length > 0) {
                deleteIds.forEach(id => formData.append('delete_ids[]', id.toString()));
            }

            return await PropertyRepository.uploadMediaAsync(propertyId, formData);
        } catch (error) {
            console.error('Error uploading media:', error);
            throw error;
        }
    }

    static async deleteMedia(mediaId: number) {
        try {
            return await PropertyRepository.deleteMedia(mediaId);
        } catch (error) {
            console.error(`Error deleting media ${mediaId}:`, error);
            throw error;
        }
    }

    static async deleteProperty(id: number) {
        try {
            return await PropertyRepository.delete(id);
        } catch (error) {
            console.error(`Error deleting property ${id}:`, error);
            throw error;
        }
    }
}
